import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config || {};
    if (err.response?.status === 401 && !cfg._retry && !cfg.url?.includes("/auth/")) {
      cfg._retry = true;
      refreshing = refreshing || api.post("/auth/refresh").finally(() => (refreshing = null));
      try {
        await refreshing;
        return api(cfg);
      } catch (refreshError) {
        if([401,403].includes(refreshError.response?.status))window.dispatchEvent(new Event("jarvis:logout"));
      }
    }
    return Promise.reject(err);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Error desconocido";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  if (d.message) return d.message;
  return JSON.stringify(d);
}

export async function downloadFile(path, filename) {
  const r = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

export const STATUS_LABEL = {
  conectado: "Conectado", desconectado: "Desconectado", pendiente: "Pendiente", error: "Error", desconocido: "Desconocido",
};

export const CMD_LABEL = {
  pendiente: "Pendiente", reclamada: "Reclamada", ejecutando: "Ejecutando", confirmada: "Confirmada",
  fallida: "Fallida", incierta: "Incierta", cancelada: "Cancelada", vencida: "Vencida",
};
